import { Link } from "react-router-dom";
import { Project } from "@/data/projects";

const ProjectCard = ({ project }: { project: Project }) => {
  return (
    <Link to={`/projects/${project.slug}`} className="group block">
      <div className="aspect-[4/3] overflow-hidden bg-muted mb-4">
        <img
          src={project.image}
          alt={`${project.name} ${project.location} — ${project.assetClass} development`}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />
      </div>
      <h3 className="heading-card mb-1">{project.name}</h3>
      <p className="text-sm text-muted-foreground">{project.location}</p>
    </Link>
  );
};

export default ProjectCard;
